<template>
  <div class="step-destino">
    <div v-if="!campoVisivel(item.local, 'tipoMidia')" class="step-destino__vazio">
      <CIcon name="cil-info" size="lg" class="step-destino__vazio-icon" />
      <p>
        O local <strong>{{ getLocalLabel(item.local) }}</strong> não usa destino:
        o banner é apenas exibido como imagem.
      </p>
    </div>

    <template v-else>
      <div class="step-destino__section">
        <div class="section-label">Tipo de mídia</div>
        <div class="step-destino__tipos-grid">
          <SelectableCard
            v-for="tipo in tipos"
            :key="tipo.key"
            :value="tipo.key"
            :label="tipo.label"
            :description="tipo.description"
            :icon="tipo.icon"
            :selected="item.tipo === tipo.key"
            @select="selecionarTipo"
          />
        </div>
        <div v-if="validacao.firstError('item.tipo')" class="message">
          {{ validacao.firstError("item.tipo") }}
        </div>
      </div>

      <div class="form-group" v-if="item.tipo === 'LINK_INTEGRADO'">
        <label class="field-label">{{ destinoLabel }}</label>
        <EntidadeAutocomplete
          entidade="linkIntegrado"
          v-model="item.link_integrado_id"
          :valueLabel="item.link_integrado_descricao"
        />
        <div v-if="validacao.firstError('item.link_integrado_id')" class="message">
          {{ validacao.firstError("item.link_integrado_id") }}
        </div>
      </div>

      <div class="form-group" v-else>
        <label class="field-label">{{ destinoLabel }}</label>
        <input
          class="form-control form-control-sm"
          v-model="item.href"
          maxlength="1000"
          :placeholder="destinoPlaceholder"
        />
      </div>

      <div class="step-destino__section">
        <div class="section-label">Comportamento</div>
        <BooleanToggle
          label="Abrir em nova aba"
          :value="!!item.nova_aba"
          @input="(valor) => atualizar('nova_aba', valor)"
        />
        <BooleanToggle
          v-if="campoVisivel(item.local, 'popup')"
          label="Abrir em pop-up"
          :value="!!item.popup"
          @input="(valor) => atualizar('popup', valor)"
        />
      </div>
    </template>
  </div>
</template>

<script>
import SelectableCard from "@/views/Campanhas/components/CampanhasComerciais/shared/SelectableCard.vue";
import BooleanToggle from "@/views/Campanhas/components/CampanhasComerciais/shared/BooleanToggle.vue";
import EntidadeAutocomplete from "@/components/Filtros/EntidadeAutocomplete";
import {
  TIPOS,
  campoVisivel,
  getDestinoLabel,
  getLocalLabel,
  getNovaAbaPadrao,
} from "../helpers/bannerLabels";

export default {
  name: "StepDestino",
  components: { SelectableCard, BooleanToggle, EntidadeAutocomplete },
  props: {
    item: {
      type: Object,
      required: true,
    },
    validacao: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      tipos: TIPOS,
    };
  },
  computed: {
    destinoLabel() {
      return getDestinoLabel(this.item.tipo);
    },
    destinoPlaceholder() {
      return this.item.tipo === "VIDEO_YOUTUBE"
        ? "Ex: dQw4w9WgXcQ"
        : "https://...";
    },
  },
  methods: {
    campoVisivel,
    getLocalLabel,
    atualizar(campo, valor) {
      this.$set(this.item, campo, valor);
    },
    selecionarTipo(tipo) {
      if (this.item.tipo === tipo) {
        return;
      }

      this.$set(this.item, "tipo", tipo);
      // Cada tipo tem um padrão de abertura próprio, como no comportamento antigo
      this.$set(this.item, "nova_aba", getNovaAbaPadrao(tipo));
    },
  },
};
</script>

<style scoped>
.step-destino .form-group {
  margin-bottom: 10px;
}

.field-label {
  font-size: 11px;
  font-weight: 600;
  color: #667085;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  margin-bottom: 3px;
  display: block;
}

.message {
  font-size: 11px;
  color: #d92d20;
  margin-top: 2px;
}

.step-destino__section {
  margin-top: 12px;
  margin-bottom: 12px;
}

.section-label {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  color: #888;
  letter-spacing: 0.5px;
  margin-bottom: 6px;
}

.step-destino__tipos-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
}

.step-destino__vazio {
  text-align: center;
  padding: 32px 20px;
  color: #98a2b3;
}

.step-destino__vazio-icon {
  color: #d0d5dd;
  margin-bottom: 8px;
}

.step-destino__vazio p {
  font-size: 13px;
  margin: 0;
}

@media (max-width: 768px) {
  .step-destino__tipos-grid {
    grid-template-columns: 1fr;
  }
}
</style>
